<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="wrapper" v-if="!isLoading">
      <div
        class="actions d-flex justify-content-between mb-4"
        v-if="!$isCallCenter"
      >
        <sc-button
          variant="danger"
          v-if="canCancel"
          :disabled="isDisable"
          @click="handleClickCancelButton"
          >ยกเลิกนัด</sc-button
        >
        <div>
          <sc-button
            variant="warning"
            v-if="canConfirm"
            :disabled="isDisable"
            @click="handleClickProviderConfirmButton"
            >ผู้ให้บริการยืนยันวันนัด</sc-button
          >
          <sc-button
            variant="success"
            v-if="canFulfill"
            :disabled="isDisable"
            @click="handleClickFulfillAsCustomerButton"
            >ยืนยันการรับบริการแทนลูกบ้าน</sc-button
          >
        </div>
      </div>
      <div class="row">
        <div class="col-3 meta">
          <div>
            <p class="font-red" v-if="isUserForOfflinePurchaseByAdmin">
              *ซื้อนอกระบบลูกค้าไม่โหลด App
            </p>
          </div>
          <div class="label">สถานะ</div>
          <div class="text status" :class="statusClassList">
            {{ statusText }}
          </div>
          <div class="label">วันรับบริการ</div>
          <div class="text">
            {{ appointmentDate }}
          </div>
          <div class="text mb-1" v-show="!isFastFixServiceType">
            {{ appointmentTime }}
          </div>
          <sc-button
            v-if="canChangeDate"
            class="w-100 mb-4"
            variant="secondary"
            @click="handleClickChangeAppointmentDateButton"
            >เปลี่ยนวันนัด</sc-button
          >
          <div class="label">นัดเมื่อ</div>
          <div class="text">{{ creationDate }}</div>
          <div class="title border-top pt-3">รายละเอียดผู้นัด</div>
          <div class="label mt-2">บ้านเลขที่ :</div>
          <div class="text">{{ homeAddress }}</div>
          <div class="label mt-1">โครงการ :</div>
          <div class="text">{{ homeProject }}</div>
          <div class="label mt-1">ชื่อ :</div>
          <div class="text">{{ contactName }}</div>
          <div class="label mt-1">เบอร์ติดต่อ :</div>
          <div class="text">{{ contactPhoneNumber }}</div>
          <div class="mt-3 border-top" v-if="isProviderFulfilled">
            <div class="title">รายละเอียดช่างปิดงาน</div>
            <div class="label mt-2">ปิดงานเมื่อ :</div>
            <div class="text">{{ providerFulfilledAt }}</div>
            <div class="label mt-1">รายละเอียดการให้บริการ :</div>
            <div class="text">{{ providerFulfilledMessage }}</div>
            <div class="mt-1" v-if="providerFulfilledImages">
              <div class="label">รูปปิดงาน :</div>
              <div>
                <img
                  v-for="(image, index) in providerFulfilledImages"
                  :key="index"
                  :src="image"
                  @click="handleShowImage(image)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-9 content">
          <div class="pb-4">
            <appointment-action-history :value="appointment.id">
            </appointment-action-history>
          </div>
          <div class="pb-2 mb-2 border-bottom" v-show="isFastFixServiceType">
            <div class="label">หมายเลขบริการ Fast Fix</div>
            <div class="text">{{ fastFixRefCode }}</div>
          </div>
          <div class="mb-4">
            <div class="label">
              หมายเหตุของลูกบ้าน
              <sc-button
                variant="primary"
                size="sm"
                v-show="isEditingNote"
                @click="handleSaveChangeNote"
                >บันทึก</sc-button
              >
              <sc-button
                variant="danger"
                size="sm"
                v-show="isEditingNote"
                @click="handleCancelChangeNote"
                >ยกเลิก</sc-button
              >
              <sc-button
                variant="secondary"
                size="sm"
                v-show="!isEditingNote && isFastFixServiceType"
                @click="handleOpenNoteEditor"
                >แก้ไข</sc-button
              >
            </div>
            <div class="text" v-show="!isEditingNote">{{ note }}</div>
            <el-input
              class="mt-2"
              v-model="editNote"
              v-show="isEditingNote"
            ></el-input>
          </div>
          <hr />
          <div class="mb-4">
            <div class="label">
              ชื่อแพ็กเกจ
            </div>
            <div class="name">
              <router-link
                target="_blank"
                :to="{
                  name: 'SubscriberDetailPage',
                  params: { id: subscriptionMemberId }
                }"
                >{{ name }}</router-link
              >
            </div>
          </div>
          <hr />
          <service-detail
            v-bind="service"
            @newProvider="handleSelectProvider"
          ></service-detail>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-2" v-if="isFulfilledStatus">
          <div class="label mb-2">วันที่ใบเสร็จ</div>
          <el-date-picker class="date-width" v-model="receiptDate" />
        </div>
        <div class="col-3" v-if="isFulfilledStatus">
          <div class="label mb-2">เลขที่ใบเสร็จ</div>
          <el-input v-model="receiptNo" />
        </div>
        <div class="col-3">
          <div class="label mb-2">ต้นทุนจริง</div>
          <el-input
            v-model="cost"
            :disabled="appointment.canNotEditAppointmentCost"
          />
        </div>
        <div class="col-1">
          <sc-button
            class="mt-4"
            size="sm"
            variant="warning"
            @click="handleSubmitAppointmentReceipt"
            >บันทึก</sc-button
          >
        </div>
      </div>
    </div>
    <confirm
      :data="confirmDialog"
      v-if="confirmDialog.isShow"
      @confirm="handleConfirm"
    >
      <div class="mb-3">
        <date-picker
          :value="form.dateTime"
          @input="handleChangeDateTime"
          class="mb-2 w-100"
        ></date-picker>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="label mb-2">เวลาที่เริ่ม</div>
          <el-time-picker
            :value="form.timeStart"
            @input="handleChangeTime($event, 'START')"
            class="mb-2"
            format="HH:mm"
            type="time"
          ></el-time-picker>
        </div>
        <div class="col-6">
          <div class="label mb-2">เวลาที่สิ้นสุด (Optional)</div>
          <el-time-picker
            :value="form.timeEnd"
            @input="handleChangeTime($event, 'END')"
            class="mb-2"
            format="HH:mm"
            type="time"
          ></el-time-picker>
        </div>
      </div>
    </confirm>
  </page-wrapper>
</template>

<script>
import {
  Input as ElInput,
  Select as ElSelect,
  Option as ElOption,
  DatePicker as ElDatePicker,
  TimePicker as ElTimePicker
} from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { DateTime } from "luxon";
import {
  toLocaleTH,
  getDurationAppointmentTimeText,
  convertDateTimeToTimeText
} from "@/lib/dateTime";
import ServiceDetail from "../components/ServiceDetail";
import { AppointmentStatus } from "../models/AppointmentStatus";
import { baanRueJaiClient } from "@/dependencies";
import DatePicker from "@/lib/components/DatePicker";
import Confirm from "@/components/helper/dialog/Confirm";
import {
  convertPriceStringToInt,
  convertBathToStangAndRoundTwoDecimal,
  convertStangToBathAndRoundTwoDecimal
} from "@/lib/formatter";
import AppointmentActionHistory from "../components/AppointmentActionHistory";
import { existValueAndEmptyString } from "@/lib/util";

export default {
  components: {
    PageWrapper,
    ScButton,
    ServiceDetail,
    DatePicker,
    ElInput,
    ElSelect,
    ElOption,
    Confirm,
    ElDatePicker,
    ElTimePicker,
    "appointment-action-history": AppointmentActionHistory,
    AppointmentStatus
  },
  data() {
    const title = "รายละเอียดการนัดหมาย";
    const isLoading = true;
    const appointment = null;
    const form = {
      dateTime: null,
      timeStart: null,
      timeEnd: null
    };
    const confirmDialog = {
      isShow: false,
      title: "เปลี่ยนแปลงวันนัด",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก"
    };
    const statusMap = {
      CREATED: "นัดใหม่",
      CANCELLED: "ยกเลิก",
      CONFIRMED: "ยืนยัน",
      WAIT_CONFIRMED_SERVICE_COMPLETE: "ยืนยัน",
      PROVIDER_FULFILLED: "ช่างปิดงาน",
      FULFILLED: "เสร็จสิ้น"
    };

    return {
      title,
      isLoading,
      appointment,
      form,
      confirmDialog,
      editNote: "",
      isEditingNote: false,
      subscriptionId: null,
      subscriptionMemberId: null,
      serviceId: null,
      receiptDate: null,
      receiptNo: null,
      cost: null,
      dateTimeSelected: null,
      dateTimeStartSelected: null,
      dateTimeEndSelected: null,
      statusMap,
      isDisable: false
    };
  },
  computed: {
    appointmentDate() {
      return toLocaleTH(this.appointment.dateTime).toFormat("dd MMMM yyyy");
    },
    appointmentTime() {
      return getDurationAppointmentTimeText(
        this.dateTimeStartSelected,
        this.dateTimeEndSelected
      );
    },
    creationDate() {
      return toLocaleTH(this.appointment.createdAt).toFormat(
        "dd MMMM yyyy HH:mm น."
      );
    },
    homeAddress() {
      return this.appointment.home.address;
    },
    homeProject() {
      return this.appointment.home.project;
    },
    contactName() {
      return this.appointment.contact.name;
    },
    contactPhoneNumber() {
      return this.appointment.contact.phoneNumber;
    },
    contactPhoneNumber() {
      return this.appointment.contact.phoneNumber;
    },
    service() {
      return this.appointment.service;
    },
    name() {
      return this.appointment.service.name || "-";
    },
    canCancel() {
      return this.appointment.constraint.canCancel;
    },
    canConfirm() {
      return this.appointment.constraint.canConfirm;
    },
    canFulfill() {
      return this.appointment.constraint.canFulfill;
    },
    canChangeDate() {
      return (
        this.appointment.constraint.canChangeDate &&
        this.appointment.status !== AppointmentStatus.CANCELLED
      );
    },
    now() {
      return DateTime.utc();
    },
    showStatus() {
      return this.appointment.note;
    },
    statusClassList() {
      return [this.appointment.status.toLowerCase()];
    },
    note() {
      return this.appointment.note || "-";
    },
    statusText() {
      return this.statusMap[this.appointment.status];
    },
    fastFixRefCode() {
      return this.appointment.fastFixRefcode || "-";
    },
    isFastFixServiceType() {
      return this.appointment.service.type === "FAST_FIX";
    },
    isFulfilledStatus() {
      return this.appointment.status === "FULFILLED";
    },
    isUserForOfflinePurchaseByAdmin() {
      return this.appointment.contact.isUserForOfflinePurchaseByAdmin;
    },
    isProviderFulfilled() {
      return this.appointment && this.appointment.providerFulfilled;
    },
    providerFulfilledAt() {
      return convertDateTimeToTimeText(
        this.appointment.providerFulfilled.fulfilledAt
      );
    },
    providerFulfilledMessage() {
      return this.appointment.providerFulfilled.message;
    },
    providerFulfilledImages() {
      return this.appointment.providerFulfilled.images;
    }
  },
  watch: {},
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      await this.setupData();
      this.setupForm();
      this.isLoading = false;
    },
    async setupData() {
      const data = await this.fetchData();

      const {
        id,
        date_time,
        created_at,
        service,
        provider,
        status,
        project,
        home,
        user,
        note,
        fast_fix_refcode,
        constraint,
        subscription_id: subscriptionId,
        subscription_member_id: subscriptionMemberId,
        actual_cost: actualCost,
        receipt_date: receiptDate,
        receipt_number: receiptNumber,
        main_option: mainOption,
        extra_option: extraOption,
        quality_unit_text: qualityUnitText,
        date_time_end: dateTimeEnd,
        is_generate_sap_mm_report: isGenerateSapMmReport,
        provider_fulfilled_at: providerFulfilledAt,
        provider_fulfilled_detail: providerFulfilledMessage,
        provider_fulfilled_image_urls: providerFulfilledImageUrls
      } = data;

      const providerFulfilledImages = providerFulfilledImageUrls
        ? providerFulfilledImageUrls.filter(image =>
            existValueAndEmptyString(image)
          )
        : [];

      const appointment = {
        id,
        note,
        dateTime: DateTime.fromISO(date_time).toUTC(),
        createdAt: DateTime.fromISO(created_at).toUTC(),
        service: {
          id: service.id.toString(),
          type: service.type,
          iconUrl: service.icon_url,
          name: service.name,
          shortDescription: service.short_description || "ไม่มีข้อมูล",
          description: service.description || "ไม่มีข้อมูล",
          termsAndConditions: service.terms_and_conditions || "ไม่มีข้อมูล",
          provider: {
            id: provider.id.toString(),
            name: provider.name,
            logoUrl: provider.logo_url,
            remark: provider.remark,
            isVatRegistered: provider.is_vat_registered
          },
          mainOption,
          extraOption,
          qualityUnitText
        },
        home: {
          address: home.address_no,
          project: project.project_name
        },
        contact: {
          name: `${user.first_name} ${user.last_name}`,
          phoneNumber: user.mobile_number || "-",
          isUserForOfflinePurchaseByAdmin:
            user.is_user_for_offline_purchase_by_admin
        },
        status,
        fastFixRefcode: fast_fix_refcode,
        constraint: {
          canConfirm: constraint.can_confirm_appointment,
          canFulfill: constraint.can_confirm_service_complete,
          canChangeDate: constraint.can_change_appointment_date,
          canCancel: constraint.can_cancel_appointment
        },
        canNotEditAppointmentCost: isGenerateSapMmReport === true,
        providerFulfilled: providerFulfilledAt
          ? {
              fulfilledAt: DateTime.fromISO(providerFulfilledAt).toUTC(),
              message: providerFulfilledMessage,
              images:
                providerFulfilledImages.length > 0
                  ? providerFulfilledImages
                  : null
            }
          : null
      };

      this.receiptDate = receiptDate ? receiptDate : null;
      this.receiptNo = receiptNumber || null;
      this.cost =
        actualCost !== null
          ? convertBathToStangAndRoundTwoDecimal(actualCost)
          : null;
      this.serviceId = service.id;
      this.subscriptionId = subscriptionId;
      this.subscriptionMemberId = subscriptionMemberId;
      this.appointment = appointment;
      this.editNote = appointment.note;
      this.dateTimeSelected = appointment.dateTime;
      this.dateTimeStartSelected = appointment.dateTime;
      this.dateTimeEndSelected = dateTimeEnd || null;
    },
    async setupForm() {
      this.form.dateTime = this.appointment.dateTime;
      this.form.timeStart = this.appointment.dateTime;
      this.form.timeEnd = this.dateTimeEndSelected;
    },
    async fetchData() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.subscriptions.appointments.get(
        id
      );

      const result = response.data.result;

      if (
        result.appointment_id_for_redirect_page &&
        result.appointment_id_for_redirect_page !== result.id
      ) {
        this.$router.push({
          name: "AppointmentDetailPage",
          params: { id: result.appointment_id_for_redirect_page }
        });

        window.location.reload();
      }

      return result;
    },
    async handleClickCancelButton() {
      if (!confirm("ยืนยันการยกเลิกนัด")) {
        return;
      }

      this.isDisable = true;

      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.subscriptions.appointments.update(
        id,
        { status: "CANCELLED" }
      );

      this.$router.push({ name: "AppointmentListPage" });
    },
    async handleClickProviderConfirmButton() {
      if (!confirm("ผู้ให้บริการยืนยันวันนัด")) {
        return;
      }

      this.isDisable = true;

      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.subscriptions.appointments.update(
        id,
        { status: "CONFIRMED" }
      );

      window.location.reload();
      return;
    },
    async handleClickFulfillAsCustomerButton() {
      if (!confirm("ยืนยันการได้รับบริการแทนลูกบ้าน")) {
        return;
      }

      this.isDisable = true;

      const { id } = this.$route.params;
      const params = {
        status: "FULFILLED",
        serviceId: this.serviceId,
        subscriptionId: this.subscriptionId
      };

      try {
        const response = await baanRueJaiClient.admin.subscriptions.appointments.update(
          id,
          params
        );
      } catch (err) {
        if (err.response && err.response.data && err.response.data.errorCode) {
          if (err.response.data.errorCode === "EZTAX_NOT_SUCCESS_ERROR") {
            alert("มีการสร้างใบเสร็จรายครั้งแล้ว แต่ไม่สามารถส่ง eztax ได้");
          } else {
            alert(err.response.data.message);
          }
        }
      }

      window.location.reload();
      return;
    },
    async handleClickChangeAppointmentDateButton() {
      this.confirmDialog.isShow = true;
    },
    async handleConfirm(isConfirm) {
      if (!isConfirm) {
        this.confirmDialog.isShow = false;
        this.setupForm();
        return;
      }

      try {
        const { id } = this.$route.params;
        const { dateTime, timeStart, timeEnd } = this.form;

        let timeStartSetFormat = timeStart;
        if (timeStart instanceof DateTime) {
          timeStartSetFormat = timeStart.toJSDate();
        }

        const date = dateTime.setZone("utc+7").set({
          hours: timeStartSetFormat.getHours(),
          minutes: timeStartSetFormat.getMinutes()
        });

        let dateEnd;
        if (timeEnd) {
          let timeEndSetFormat = timeEnd;
          if (typeof timeEnd === "string") {
            timeEndSetFormat = new Date(timeEnd);
          } else if (timeEnd instanceof DateTime) {
            timeEndSetFormat = timeEnd.toJSDate();
          }

          dateEnd = dateTime.setZone("utc+7").set({
            hours: timeEndSetFormat.getHours(),
            minutes: timeEndSetFormat.getMinutes()
          });
        }

        await baanRueJaiClient.admin.subscriptions.appointments.putDate(id, {
          date,
          date_end: dateEnd || undefined
        });

        await this.setupData();
        this.confirmDialog.isShow = false;
      } catch (error) {
        console.error(error);
        alert("ไม่สามารถเปลี่ยนวันนัดได้");
      }
    },
    handleChangeDateTime(dateTime) {
      if (!dateTime) {
        this.form.dateTime = this.dateTimeSelected;
        this.form.timeStart = this.dateTimeStartSelected;
        this.form.timeEnd = this.dateTimeEndSelected;
        return;
      }

      const updatedDateTime = dateTime.setZone("utc+7");
      this.form.dateTime = updatedDateTime.toUTC();

      const now = DateTime.now();
      const isMorningTime = now < now.set({ hour: 12 });

      this.form.timeStart = isMorningTime
        ? updatedDateTime.set({ hour: 9 })
        : updatedDateTime.set({ hour: 13 });

      this.form.timeEnd = isMorningTime
        ? updatedDateTime.set({ hour: 12 })
        : updatedDateTime.set({ hour: 16 });
    },
    async handleSaveChangeNote() {
      if (!confirm("คุณต้องการบันทึกการแก้ไข หมายเหตุของลูกบ้าน หรือไม่")) {
        return;
      }

      try {
        const { id } = this.$route.params;
        const params = { note: this.editNote };
        const response = await baanRueJaiClient.admin.subscriptions.appointments.updateNote(
          id,
          params
        );

        alert("แก้ไขหมายเหตุของลูกบ้านสำเร็จ");

        this.isEditingNote = false;
        this.appointment.note = this.editNote;
      } catch (error) {
        alert("ไม่สามารถแก้ไขหมายเหตุได้ กรุณาลองใหม่อีกครั้ง");
        console.error(error);
      }
    },
    handleCancelChangeNote() {
      if (!confirm("คุณต้องการยกเลิกการแก้ไข หมายเหตุของลูกบ้าน หรือไม่")) {
        return;
      }

      this.isEditingNote = false;
      this.editNote = this.appointment.note;
    },
    handleOpenNoteEditor() {
      this.isEditingNote = true;
    },
    async handleSubmitAppointmentReceipt() {
      const { id } = this.$route.params;

      const params = {
        appointment_id: id,
        receipt_date: this.receiptDate
          ? DateTime.fromJSDate(new Date(this.receiptDate))
              .endOf("day")
              .toUTC()
              .toISO()
          : this.receiptDate,
        receipt_number: this.receiptNo || null,
        actual_cost: convertPriceStringToInt(this.cost)
      };

      try {
        await baanRueJaiClient.admin.subscriptions.appointments.putAppointmentReceipt(
          id,
          params
        );

        alert("บันทึกข้อมูลเรียบร้อย");
      } catch (error) {
        alert("ไม่สามารถบันทึกข้อมูลได้");
        console.error(error);
      }
    },
    handleChangeTime(time, type) {
      const isStartTime = type === "START";
      if (!time) {
        if (isStartTime) this.form.timeStart = this.dateTimeStartSelected;
        if (!isStartTime) this.form.timeEnd = this.dateTimeEndSelected;
      }

      if (isStartTime) {
        this.form.timeStart = time;
      } else {
        this.form.timeEnd = time;
      }
    },
    async handleSelectProvider(provider) {
      const { id } = this.$route.params;
      try {
        await baanRueJaiClient.admin.subscriptions.appointments.updateProviderAndActualCost(
          id,
          {
            provider_id: +provider.id,
            actual_cost:
              this.cost !== null && this.cost >= 0
                ? convertStangToBathAndRoundTwoDecimal(this.cost)
                : null
          }
        );
      } catch (err) {
        console.log(err);
        alert("ไม่สามารถบันทึกผู้ให้บริการและราคาต้นทุนจริงได้");
      }

      await this.setupData();
    },
    handleShowImage(image) {
      window.open(image, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.meta {
  border-right: $border;
}

.status {
  font-weight: bold;

  &.created {
    color: $secondary-color;
  }

  &.cancelled {
    color: $danger-color;
  }

  &.confirmed,
  &.wait_confirmed_service_complete {
    color: $warning-color;
  }

  &.provider-fulfilled {
    color: $success-dark-color;
  }

  &.fulfilled {
    color: $success-color;
  }
}

.title {
  font-weight: bold;
}

.label {
  color: #808080;
  font-size: 0.9rem;
}

.title,
.text,
.name {
  color: black;
  font-size: 1rem;
}

.title,
.text + .label {
  margin-top: 16px;
}

.date-width {
  width: auto;
}

.font-red {
  color: rgb(250, 102, 102);
}

img {
  border-radius: 4px;
  width: 55px;
  height: 55px;
  margin-top: 8px;
  margin-right: 8px;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/appointments/pages/AppointmentDetailPage.vue